import { type MemoryConfig, MemoryConfigSchema } from '@timelyapp/integration-cloud-api-spec';
import type { IState } from 'redux/state';
import { createSelector } from 'reselect';
import { ticApi as rawTicApi } from './api-slice/GENERATED_ARTIFACT';
import { getDefaultMemoryConfig, getIsViewingDefaults } from './tic.config_defaults';

const getRawTicApiSlice = (state: IState) => state[rawTicApi.reducerPath];

/**
 * Returns the user-defined Memory config (from db `memory_filters`)
 */
export const getMemoryConfig = createSelector(
  [getRawTicApiSlice, getIsViewingDefaults, getDefaultMemoryConfig],
  (localState, isViewingDefaults, defaultMemoryConfig): MemoryConfig => {
    if (isViewingDefaults) {
      return MemoryConfigSchema.parse(defaultMemoryConfig ?? {});
    }
    const memoryConfig = rawTicApi.endpoints.getMemoryConfig.select(undefined)({
      [rawTicApi.reducerPath]: localState,
    }).data?.filters;

    // If minutesPerBlock is less than 15 (except 0 which means summary lane is disabled),
    // we force a minimum pxPerMinute to avoid overflowing/hidden text in summary blocks.
    const minutesPerBlock = memoryConfig?.minutesPerBlock ?? 15;
    const minPxPerMinute =
      minutesPerBlock === 0 || minutesPerBlock > 15
        ? 1
        : minutesPerBlock < 10
          ? 3
          : minutesPerBlock < 15
            ? 2
            : 1;
    const pxPerMinute = Math.max(minPxPerMinute, memoryConfig?.pxPerMinute ?? 2);

    return MemoryConfigSchema.parse({ ...memoryConfig, pxPerMinute, minPxPerMinute });
  }
);
